<template>
  <div class="my-4">
    <CommonDataTable :keySearch="keySearch" />
  </div>
</template>
<script>
import CommonDataTable from "../../../screens/adminScreen/common/CommonDataTable";
export default {
  data() {
    return {
      keySearch: "",
    };
  },
  components: { CommonDataTable },
};
</script>
